<template>

<div>
<v-container class="my-5">
        
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3 v-for="person in contacts" :key="person.name">
                <v-card flat class="text-xs-center ma-3">
                  <div class="primary subheading text-uppercase white--text">{{person.contactType}}</div>
                    <v-responsive class="pt-4">
                        <v-avatar size="100" class="grey lighten-2">
                            <img :src="person.avatar">
                        </v-avatar>
                    </v-responsive>
                    <v-card-text>
                        <div class="subheading">{{person.name}} {{person.surname}}</div>
                        <div class="grey--text">M: {{person.mobileNumber}}</div>
                        <div class="grey--text">T: {{person.telephoneNumber}}</div>
                        <div class="grey--text" prepend-icon="email">{{person.emailAddress}}</div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>


</div>
</template>

<script>
export default {
        props:['contacts']
}
</script>

